// extracted by mini-css-extract-plugin
export default {"icons":"game-card-icons_icons__mPozS","icon":"game-card-icons_icon__WoJLF","icon_tooltip":"game-card-icons_icon_tooltip__d1q3k"};